import React from 'react';
import './Plan.css'; // Import your CSS file

import { Button } from '../../components';

import { FaCheck } from 'react-icons/fa';



const Plan = ({ plan }) => {

  const { title, price, unit, features } = plan;

  return (
    <div className="plan-item">
      <h3>{title}</h3> {/* Plan Title */}
      <div className='price'>${price}</div> {/* Plan Price */}
      <span>{unit}</span> {/* Plan Price */}
      {/* List of Features */}
      <ul>
        {features.map((feature, index) => (
          <li key={index}><div className='icon'><FaCheck /></div> {feature}</li> 
        ))}
      </ul>
      <Button link={"Order-Now"} title={"order now"} />
    </div>
  );
};

export default Plan;